var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-subtitle',{attrs:{"loading":_vm.sorting || _vm.loading,"refresh":""},on:{"refresh":_vm.getMenu}},[_vm._v("Left Menu ")]),_c('m-draggable',{attrs:{"items":_vm.items,"item-text":function (a) {
        return a.text || a.name;
      }},on:{"onSort":_vm.onSort}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }